import React, { useEffect, useRef, useState } from "react";
import { useMyText } from "./text";
import { bizFmt, bizMask } from "./format";
import "./my.css";

// 헤더 사업자번호 칩 + 계정 메뉴(시안 renderChip)
export default function AccountMenu({ customer, badges, onGo, onLogout }) {
    const tt = useMyText();
    const [open, setOpen] = useState(false);
    const ref = useRef(null);
    useEffect(() => {
        if (!open) return undefined;
        const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
        const onKey = (e) => { if (e.key === "Escape") setOpen(false); };
        document.addEventListener("mousedown", onDoc);
        document.addEventListener("keydown", onKey);
        return () => { document.removeEventListener("mousedown", onDoc); document.removeEventListener("keydown", onKey); };
    }, [open]);

    const biz = customer?.business_number || "";
    // 안 읽은 완료가 있으면 그 수(빨강), 없으면 진행 중 수
    const count = badges.unread || badges.open;
    const pick = (fn) => () => { setOpen(false); fn(); };
    const sub = [tt("menu.bizLine", { biz: bizFmt(biz) }), customer?.owner_name && tt("menu.owner", { name: customer.owner_name })].filter(Boolean).join(" · ");
    return (
        <div className="my-chip-wrap" ref={ref}>
            <button type="button" className={`my-chip ${open ? "on" : ""}`} aria-haspopup="menu" aria-expanded={open} onClick={() => setOpen((v) => !v)}>
                <span>{bizMask(biz)}</span>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" aria-hidden="true"><path d="M6 9l6 6 6-6" /></svg>
                {badges.unread > 0 && <span className="my-chip-dot" aria-hidden="true" />}
            </button>
            {open && (
                <div className="my-acc" role="menu">
                    <div className="my-acc-h">
                        <b>{customer?.business_name}</b>
                        <span>{sub}</span>
                    </div>
                    <button type="button" role="menuitem" className="my-acc-i" onClick={pick(() => onGo("inq"))}>
                        {tt("menu.inq")}
                        {count > 0 && <span className={`my-acc-bd ${badges.unread > 0 ? "red" : ""}`}>{count}</span>}
                    </button>
                    <button type="button" role="menuitem" className="my-acc-i" onClick={pick(() => onGo("log"))}>
                        {tt("menu.log")}<small>{tt("menu.logCount", { n: badges.sessions_90d })}</small>
                    </button>
                    <div className="my-acc-sep" />
                    <button type="button" role="menuitem" className="my-acc-i out" onClick={pick(onLogout)}>{tt("menu.logout")}</button>
                </div>
            )}
        </div>
    );
}
